/* eslint-disable react/jsx-no-bind */
import React, { useEffect, useState } from 'react';
import { Table, Schema, Button } from 'rsuite';
import { toast } from 'react-toastify';
import { Plus } from '@rsuite/icons';

import { Container } from '~/styles/tabela';

import api from '~/services/api';
import {
  CelulaEditavel,
  CelulaAcao,
} from '~/components/Celulas/components/CelulaEditavel';
import { Modal2 } from '~/components/ModalCriacao/Modal2';
import { Modal1 } from '~/components/ModalCriacao/Modal1';
import { TabelaSemPaginacao } from '~/components/TabelaSemPaginacao';
import SearchTable from '../components/SearchTable';
import PageHeader from '../../../components/PageHeader';
import Card from '../../../components/Card';

const { HeaderCell, Column } = Table;

const { StringType } = Schema.Types;

const modelo = Schema.Model({
  idioma: StringType().isRequired('Idioma Obrigatório'),
});

function Idiomas() {
  const [dados, setDados] = useState({
    idiomasLista: [],
    idiomasListaFiltrada: [],
    filtro: '',
    objeto: {},
  });
  const [apagarIdiomaDialog, setApagarIdiomaDialog] = useState({
    exibir: false,
    idioma: {},
  });
  const [carregando, setCarregando] = useState(true);
  const [adicionarIdiomaDialog, setAdicionarIdiomaDialog] = useState(false);
  const [camposInput, setCamposInput] = useState({});

  async function buscarIdiomas() {
    const resposta = await api.get('idioma');
    // const resposta1 = await api.get('idioma');
    setDados({
      idiomasLista: resposta.data,
      idiomasListaFiltrada: resposta.data,
      // listaInicial: resposta1.data,
      listaInicial: JSON.parse(JSON.stringify(resposta.data)),
    });
    setCarregando(false);
  }

  useEffect(() => {
    buscarIdiomas();
  }, []);

  function filtrarLista(texto) {
    setDados({
      ...dados,
      idiomasListaFiltrada: dados.idiomasLista.filter((idioma) =>
        idioma.idioma
          .toString()
          .toUpperCase()
          .includes(texto ? texto.toUpperCase() : '')
      ),
      filtro: texto,
    });
  }

  function abrirApagarDialog(idioma) {
    setApagarIdiomaDialog({
      exibir: true,
      idioma,
    });
  }

  function fecharApagarDialog() {
    setApagarIdiomaDialog({
      exibir: false,
      idioma: {},
    });
  }

  async function excluirIdioma() {
    try {
      await api.delete(`/idioma/${apagarIdiomaDialog.idioma.id}`);
      toast.success('Idioma excluido com sucesso');
      fecharApagarDialog();
      buscarIdiomas();
    } catch (e) {
      toast.error(e.message);
    }
  }

  async function adicionarIdioma() {
    try {
      setCarregando(true);
      await api.post(`/idioma`, camposInput);
      toast.success('Idioma criado com sucesso');
      setCarregando(false);
      setAdicionarIdiomaDialog(false);
      buscarIdiomas();
    } catch (e) {
      toast.error(e.message);
    }
  }

  function alterarTextoCelula(id, key, value) {
    const nextData = Object.assign([], dados.idiomasLista);
    nextData.find((item) => item.id === id)[key] = value;
    setDados({ ...dados, idiomasLista: nextData });
    filtrarLista(dados.filtro);
  }

  async function alterarEstadoCelula(id) {
    const novaLista = Object.assign([], dados.idiomasLista);
    const item = novaLista.find((idioma) => idioma.id === id);
    const itemIncial = dados.listaInicial.find((idioma) => idioma.id === id);
    if (item.status === 'EDIT' && item.idioma !== itemIncial.idioma) {
      try {
        setCarregando(true);
        await api.put(`idioma/${id}`, item);
        toast.success('Idioma atualizado com sucesso');
        buscarIdiomas();
      } catch (error) {
        toast.error(error.message);
      }
      setCarregando(false);
    } else {
      item.status = item.status ? null : 'EDIT';
      setDados({ ...dados, idiomasLista: novaLista });
      filtrarLista(dados.filtro);
    }
  }

  return (
    <Container>
      <PageHeader
        title="Idiomas"
        subtitle="Gerencie os idiomas disponíveis no sistema."
        actions={
          <Button
            appearance="primary"
            startIcon={<Plus />}
            onClick={() => setAdicionarIdiomaDialog(true)}
          >
            Novo Idioma
          </Button>
        }
      />
      <Card>

        <SearchTable
          estilo={{ width: 400 }}
          filtrarLista={filtrarLista}
        />

        <TabelaSemPaginacao
          carregando={carregando}
          dados={dados.idiomasListaFiltrada}
        >
          <Column resizable width={150}>
            <HeaderCell>Ações</HeaderCell>
            <CelulaAcao
              dataKey="id"
              onClick={alterarEstadoCelula}
              onDelete={abrirApagarDialog}
            />
          </Column>
          <Column resizable width={350} sortable>
            <HeaderCell>Idioma</HeaderCell>
            <CelulaEditavel dataKey="idioma" onChange={alterarTextoCelula} />
          </Column>

        </TabelaSemPaginacao>
      </Card>

      <Modal1
        show={adicionarIdiomaDialog}
        onHide={() => setAdicionarIdiomaDialog(false)}
        title="Adicionar Idioma"
        label="Idioma"
        name="idioma"
        model={modelo}
        onSubmit={(status) => status && adicionarIdioma()}
        onChange={setCamposInput}
        onClick={() => setAdicionarIdiomaDialog(false)}
      />

      <Modal2
        show={apagarIdiomaDialog.exibir}
        onHide={fecharApagarDialog}
        title="Apagar Idioma"
        text="Você realmente deseja apagar este idioma?"
        apagarId={apagarIdiomaDialog.idioma.id}
        apagarDado={apagarIdiomaDialog.idioma.idioma}
        fecharApagarDialog={fecharApagarDialog}
        excluir={() => excluirIdioma()}
      />
    </Container>
  );
}

export default Idiomas;
